import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-184d16fb"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "Navbar" }
const _hoisted_2 = { class: "Navbar__container" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_IconArrowLeft = _resolveComponent("IconArrowLeft")!
  const _component_RouterLink = _resolveComponent("RouterLink")!

  return (_openBlock(), _createElementBlock("nav", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createVNode(_component_RouterLink, {
        to: { name: 'Home' },
        class: "Navbar__back",
        "data-testid": "back-link"
      }, {
        default: _withCtx(() => [
          _createVNode(_component_IconArrowLeft, { size: "44" })
        ]),
        _: 1
      }),
      _createVNode(_component_RouterLink, {
        to: { name: _ctx.routeName },
        class: "Navbar__link",
        "data-testid": "external-link"
      }, {
        default: _withCtx(() => [
          _createTextVNode(_toDisplayString(_ctx.linkName), 1)
        ]),
        _: 1
      }, 8, ["to"])
    ])
  ]))
}